import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=6e0d33fe&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=6e0d33fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d33fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0d33fe')) {
      api.createRecord('6e0d33fe', component.options)
    } else {
      api.reload('6e0d33fe', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=6e0d33fe&scoped=true", function () {
      api.rerender('6e0d33fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/SAS/Components/Upload.vue"
export default component.exports